import { useEffect, useState } from 'react'
import { Modal, Spin, Switch } from 'antd'
import { updateExamWaterMarkerStatus, updateForbidReapplyUnitStatus, updateMobileApplyStatus } from '../../../../common/request'
import { useSelector } from 'react-redux'
import ResponseCode from '../../../../common/response-code'
import eventBus from '../../../../plugins/events'

function SettingBasicConfiguration () {
  const selectedExam = useSelector(state => state.examInfo.selectedExam)
  const [watermark, setWatermark] = useState(false)
  const [forbidReapplyUnitEnabled, setForbidReapplyUnitEnabled] = useState(false)
  const [mobileApplyEnabled, setMobileApplyEnabled] = useState(true)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (selectedExam.baseConfig) {
      setWatermark(Boolean(JSON.parse(selectedExam.baseConfig).watermark))
    } else {
      setWatermark(false)
    }
    setForbidReapplyUnitEnabled(selectedExam.forbidReapplyUnitStatus === 1)
    setMobileApplyEnabled(selectedExam.mobileApplyStatus !== 0)
  }, [selectedExam])

  const toggleWatermarkChange = (status) => {
    Modal.confirm({
      title: '操作确认',
      content: `确认${status ? '开启' : '关闭'}考生详情及样表水印？`,
      onOk: () => {
        setLoading(true)
        updateExamWaterMarkerStatus({
          id: selectedExam.id,
          baseConfig: JSON.stringify({
            watermark: Number(status)
          })
        }).then(res => {
          if (res.code === ResponseCode.success) {
            Modal.success({
              title: '操作成功',
              content: '已更新考试水印配置'
            })
            eventBus.emit('reloadExamDetail', selectedExam.id)
          } else {
            Modal.error({
              title: '操作失败',
              content: res.msg
            })
          }
        }).finally(() => {
          setLoading(false)
        })
      }
    })
  }

  const toggleForbidReapplyUnitChange = (status) => {
    Modal.confirm({
      title: '操作确认',
      content: `确认${status ? '开启' : '关闭'}「审核不通过，且禁止报考本职位」功能？`,
      onOk: () => {
        setLoading(true)
        updateForbidReapplyUnitStatus({
          id: selectedExam.id,
          forbidReapplyUnitStatus: status ? 1 : 0
        }).then(res => {
          if (res.code === ResponseCode.success) {
            Modal.success({
              title: '操作成功',
              content: `已${status ? '开启' : '关闭'}「审核不通过，且禁止报考本职位」功能`
            })
            eventBus.emit('reloadExamDetail', selectedExam.id)
          } else {
            Modal.error({
              title: '操作失败',
              content: res.msg
            })
          }
        }).catch(() => {
          Modal.error({
            title: '网络错误',
            content: '更新配置失败'
          })
        }).finally(() => {
          setLoading(false)
        })
      }
    })
  }

  const toggleMobileApplyChange = (status) => {
    Modal.confirm({
      title: '操作确认',
      content: `确认${status ? '开启' : '关闭'}移动端报名？`,
      onOk: () => {
        setLoading(true)
        updateMobileApplyStatus({
          id: selectedExam.id,
          mobileApplyStatus: status ? 1 : 0
        }).then(res => {
          if (res.code === ResponseCode.success) {
            Modal.success({
              title: '操作成功',
              content: `已${status ? '开启' : '关闭'}移动端报名`
            })
            eventBus.emit('reloadExamDetail', selectedExam.id)
          } else {
            Modal.error({
              title: '操作失败',
              content: res.msg
            })
          }
        }).catch(() => {
          Modal.error({
            title: '网络错误',
            content: '更新配置失败'
          })
        }).finally(() => {
          setLoading(false)
        })
      }
    })
  }

  return (
    <Spin spinning={ loading }>
      <div className="py-2">
        <div className="d-flex align-items-center mb-3">
          <div style={ { minWidth: 280 } }>移动端报名：</div>
          <Switch
            checked={ mobileApplyEnabled }
            checkedChildren="开启"
            unCheckedChildren="关闭"
            onChange={ toggleMobileApplyChange }
          ></Switch>
        </div>
        <div className="d-flex align-items-center mb-3">
          <div style={ { minWidth: 280 } }>审核不通过，且禁止报考本职位：</div>
          <Switch
            checked={ forbidReapplyUnitEnabled }
            checkedChildren="开启"
            unCheckedChildren="关闭"
            disabled={ String(selectedExam.isCheck) !== '1' }
            onChange={ toggleForbidReapplyUnitChange }
          ></Switch>
        </div>
        {
          String(selectedExam.isCheck) !== '1'
            ? <div className="text-muted mb-3" style={ { paddingLeft: 280 } }>需先开启考试审核后，方可启用该功能</div>
            : null
        }
        <div className="d-flex align-items-center">
          <div style={ { minWidth: 280 } }>考生详情及样表水印：</div>
          <Switch
            checked={ watermark }
            checkedChildren="开启"
            unCheckedChildren="关闭"
            onChange={ toggleWatermarkChange }
          ></Switch>
        </div>
      </div>
    </Spin>
  )
}

export default SettingBasicConfiguration
